/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceGsmV1InstrumentEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_GSM_V1_INSTRUMENT_EVENT_ENTITY_NAME = 'exc.ice.gsm.v1.InstrumentEvent';
export const excIceGsmV1InstrumentEventEntity = new schema.Entity<ExcIceGsmV1InstrumentEvent>(EXC_ICE_GSM_V1_INSTRUMENT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIceGsmV1InstrumentEvent) => `${entity.metadata?.eventId}` });

